import Head from 'next/head';
import { useRouter } from 'next/router';
import { type FC, useMemo } from 'react';
import { Container } from '@/DesignSystem/Component';
import { APPLICATION_TITLE } from '@/Module/Core/Constant';
import { replaceHalfSpace } from '@/Module/Core/Helper';
import { DefaultLayoutBreadcrumb } from '@/Module/DefaultLayout/Component';
import type { IGradeJson } from '@/Module/Grade/Model/DataModel';
import { LessonList, LessonListDescription, LessonListHeader } from '@/Module/Lesson/Component';
interface ILessonListPageContainerProps {
  gradeData: IGradeJson;
}
const LessonListPageContainer: FC<ILessonListPageContainerProps> = ({
  gradeData
}) => {
  const router = useRouter();
  const breadcrumb = useMemo(() => {
    if (!gradeData.title) return [];
    const items = gradeData.title.split(' | ');
    return items.map((item, index) => {
      return {
        key: index,
        title: item.replace('مقطع ', '').replace('رشته ', ''),
        href: index === 0 ? '/app/' : router.asPath
      };
    });
  }, [gradeData.title, router.asPath]);
  if (!gradeData) return null;
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="LessonListPageContainer.tsx">
        <title>{gradeData.seoTitle}</title>
        <meta name="description" content={gradeData.seoDescription} data-sentry-element="meta" data-sentry-source-file="LessonListPageContainer.tsx" />
        <meta property="og:site_name" content={replaceHalfSpace(APPLICATION_TITLE)} data-sentry-element="meta" data-sentry-source-file="LessonListPageContainer.tsx" />
        <meta property="og:title" content={gradeData.seoTitle} data-sentry-element="meta" data-sentry-source-file="LessonListPageContainer.tsx" />
        <meta property="og:description" content={gradeData.seoDescription} data-sentry-element="meta" data-sentry-source-file="LessonListPageContainer.tsx" />
        <meta property="og:type" content="website" data-sentry-element="meta" data-sentry-source-file="LessonListPageContainer.tsx" />
        <link rel="canonical" href={`https://ino.school/${router.asPath}`} />
        <meta name="twitter:title" content={gradeData.seoTitle} data-sentry-element="meta" data-sentry-source-file="LessonListPageContainer.tsx" />
        <meta name="twitter:description" content={gradeData.seoDescription} data-sentry-element="meta" data-sentry-source-file="LessonListPageContainer.tsx" />
      </Head>

      <DefaultLayoutBreadcrumb items={breadcrumb} data-sentry-element="DefaultLayoutBreadcrumb" data-sentry-source-file="LessonListPageContainer.tsx" />

      <Container data-sentry-element="Container" data-sentry-source-file="LessonListPageContainer.tsx">
        <LessonListHeader title={`دروس ${gradeData.title}`} data-sentry-element="LessonListHeader" data-sentry-source-file="LessonListPageContainer.tsx" />
        <LessonList data-sentry-element="LessonList" data-sentry-source-file="LessonListPageContainer.tsx" />
        <LessonListDescription description={gradeData.description} data-sentry-element="LessonListDescription" data-sentry-source-file="LessonListPageContainer.tsx" />
      </Container>
    </>;
};
export default LessonListPageContainer;